





























































































































import { PropType } from 'vue';
import AssetManagerBox from '@/components/asset-manager/AssetManagerBox.vue';
import { IAsset, IAssetCreateParams } from '@/services/asset';
import LoaderInline from '@/components/LoaderInline.vue';
import PropsTableMini from '@/components/PropsTableMini.vue';
import { Product } from '../../types';
import messages from '../../messages';
import ProductPrices from './ProductPrices.vue';

export default {
  props: {
    assetRecord: Object as () => IAssetCreateParams,
    assetValidation: Object,
    currencies: Array,
    exportStatus: String,
    value: Object as PropType<Product>,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value: Product) {
        this.$emit('input', value);
      },
    },
  },
  components: {
    AssetManagerBox,
    LoaderInline,
    ProductPrices,
    PropsTableMini,
  },
} as IView;
